// @flow
import React, { useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { sendAnalyticsEvent } from 'utils/analyticsWrapper';
import { nameWithPossesive } from 'utils/string';
import bgImage from 'assets/images/background.png';
import './styles.css';
import ShareProfilePopUp from 'components/shared/ShareProfile/ShareProfilePopUp';

const Avatar = (props) => {
  let content;

  if (props.imageURL) {
    content = (
      <span className="avatar boy with-avatar" style={{ padding: 0 }}>
        <img
          src={props.imageURL}
          style={{
            objectFit: 'cover',
            verticalAalign: 'middle',
            borderRadius: '50%',
            overflow: 'hidden',
            height: '100px',
            width: '100px',

          }}
          alt="avatar"
        />
      </span>
    );
  } else if (props.gender === 'girl') {
    content = (
      <span className="avatar boy">
        <span className="icon-large very-large icon-owl-girl" />
      </span>
    );
  } else {
    content = (
      <span className="avatar boy">
        <span className="icon-large very-large icon-owl-boy" />
      </span>
    );
  }

  return content;
};

const giveGoalcardClick = () => {
  sendAnalyticsEvent('Public Profile', 'public_profile_give_goalcard_click');
};

const AccountInformation = (props: Props) => {
  const location = useLocation();
  const { t } = useTranslation();

  const browserHistory = useHistory();

  const [showSharerPopUp, toggleShowSharerPopUp]: [any,
    ((any => any) | any) => void] = useState(location.pathname.includes('share'));

  if (!props.info) {
    return null;
  }

  const onShared = (e) => {
    // e.preventDefault();

    sendAnalyticsEvent('Profile Share Popup', 'profile_share_popup_open');
  };

  const onCloseSharerPopUp = () => {
    toggleShowSharerPopUp(false);
  };

  return (
    <>
      <section className="heading-section profile-heading-section kid-profile-heading" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="container">
          <div className="profile-heading-section-name">
            {props.info.firstname.trim()}
          </div>
          <div className="profile-heading-section-desc">
            <Link to={`${location.pathname}/share`} onClick={onShared}>
              <span style={{ marginRight: '10px' }}>
                {`${t('share_title')} ${props.info.firstnameWithPossesive.trim()} ${t('goals_title')}`}
              </span>
              <span className="icon-svg icon-share" />
            </Link>
          </div>

          <Avatar gender={props.info.gender} imageURL={props.info.profileImageUrl} />

          <div className="profile-heading-section-desc" />
          <Link to={{ pathname: '/selectgoalcard', state: { receiverUser: props.info } }} onClick={() => giveGoalcardClick} className="button button-purple">{t('goalcard_give')}</Link>
        </div>
      </section>

      <ShareProfilePopUp show={showSharerPopUp} onClose={onCloseSharerPopUp} />
    </>
  );
};

export default AccountInformation;
